import { Modal } from "components";
import React from "react";
import ExportModal from "./ExportModal";
import { type AxiosPromise } from "axios";
import { PhosphorDownloadSimpleButton } from "components/Atoms/PhosphorIconButton";
import { HorizontalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

interface Props<TInstruction> {
  canExportList: boolean
  instruction: TInstruction
  exportOptionsApi: (instruction: TInstruction) => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.ExportOption[]>>
}

const ExportButton = <TInstruction extends any>(props: Props<TInstruction>) => {
  const [isExportModalOpen, setIsExportModalOpen] = React.useState(false);

  if (!props.canExportList) return <></>;

  return (<div className="selectiontool-export-button">
    <PhosphorDownloadSimpleButton
      {...HorizontalKeyboardNavigationGroup("paginationRow")}
      onClick={() => { setIsExportModalOpen(true); }}
      layout="in-square"
    />

    {isExportModalOpen && <Modal
      isOpen
      handleClose={() => { setIsExportModalOpen(false); }}
      title={RESX.Template.Export}
      width="large"
    >
      <ExportModal instruction={props.instruction} exportOptionsApi={props.exportOptionsApi} />
    </Modal>}
  </div>);
};

export default ExportButton;